// extracted by mini-css-extract-plugin
export default {"subtitle":"Answer_subtitle__HKK3L","answer":"Answer_answer__+eAtW","rate":"Answer_rate__JapTh","button":"Answer_button__ezkMg","radio":"Answer_radio__LPSHA"};